import QRCode from 'qrcode.react';
import styled from 'styled-components';

export const CustomQRCode = styled(QRCode)`
  width: 100%;
  height: 100%;
  max-height: 256px;
`;
